<template>
  <div class="input-box-wrapper">
    <textarea class="input-box"
              ref="input"
              v-model="inputText"
              :disabled="disabled"
              :maxlength="maxlength"
              @input="handleInput"
              @focus="handleFocus"
              @blur="handleBlur"

    >
    </textarea>
    <span class="tip" v-show="showTip">{{tip}}</span>
  </div>

</template>

<script>
export default {
  name: 'InputArea',
  data() {
    return {
      inputText: '',
      inputLength: 0,
      showTip: false,
      focused: false,
    }
  },

  mounted() {
    const input =this.$refs.input
    input.value = this.placeholder;
    input.style = "color: #999"
  },

  props: {
    textContent: String,
    placeholder: {
      type: String,
      default() {
        return this.$t('survey.placeholder')
      }
    },
    disabled: Boolean,
    maxlength: {
      type: Number,
      default: 300,
    },
    showTipLength: {
      type: Number,
      default: 240,
    },
    isFocus: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    tip() {
      return `${this.inputLength} / ${this.maxlength}`
    }
  },
  watch: {
    inputText(n, o) {
      if(n != o) {
        this.$emit('update:textContent', n)
      }
    },
    isFocus(newVal) {
      if (newVal) {
        this.$refs.input.focus()
      }
    }

  },

  methods: {
    handleInput() {
      const len = this.inputText.length
      this.inputLength = len
      this.showTip = len >= this.showTipLength
    },
    handleFocus() {
      if(this.$refs.input.value === this.placeholder){
        const input =this.$refs.input
        input.value = '';
        input.style = ""
      }
    },
    handleBlur() {
      if(this.$refs.input.value ===''){
        const input =this.$refs.input
        input.value = this.placeholder;
        input.style = "color: #999"
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
/*清除ios输入框阴影*/
textarea
  -webkit-appearance none
  &::placeholder:after
    display:block;
    content:"line@ \A line#";/*  \A 表示换行  */
    color:red

.input-box-wrapper
  position relative
  .input-box
    white-space: pre-line;
    min-height 200px
    width 100%
    padding 20px
    border 1px solid rgb(234,234,234)
    border-radius 10px
    box-sizing border-box
    resize none
    background-color #fff
    outline none
    &[disabled]
      background-color #eee
    /[data-theme='default'] &:focus-within
      border-color $theme-color
    /[data-theme='vip'] &:focus-within
      border-color $theme-color-vip
  .tip
    position absolute
    right 0
    bottom -30px
    font-size 24px
    color #91181a
</style>
